var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDevices = function SvgDevices(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0099 12.73C17.6009 12.73 18.0799 12.251 18.0799 11.66C18.0799 11.0691 17.6009 10.5901 17.0099 10.5901C16.419 10.5901 15.9399 11.0691 15.9399 11.66C15.9399 12.251 16.419 12.73 17.0099 12.73Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6V7.78998C19.75 7.75998 19.46 7.73999 19.15 7.73999H14.87C12.73 7.73999 12.02 8.45003 12.02 10.59V15.7H6C2.8 15.7 2 14.9 2 11.7V6C2 2.8 2.8 2 6 2H16C19.2 2 20 2.8 20 6Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.7V19.9999",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.9H12",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94995 20H11.9999",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0099 12.73C17.6009 12.73 18.0799 12.251 18.0799 11.66C18.0799 11.0691 17.6009 10.5901 17.0099 10.5901C16.419 10.5901 15.9399 11.0691 15.9399 11.66C15.9399 12.251 16.419 12.73 17.0099 12.73Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.78998C19.75 7.75998 19.46 7.73999 19.15 7.73999H14.87C12.73 7.73999 12.02 8.45003 12.02 10.59V19.15C12.02 21.29 12.73 22 14.87 22H19.15C21.29 22 22 21.29 22 19.15V10.59C22 8.76003 21.48 7.97998 20 7.78998ZM17.01 10.59C17.6 10.59 18.08 11.07 18.08 11.66C18.08 12.25 17.6 12.73 17.01 12.73C16.42 12.73 15.94 12.25 15.94 11.66C15.94 11.07 16.42 10.59 17.01 10.59ZM17.01 19.15C15.83 19.15 14.87 18.19 14.87 17.01C14.87 16.52 15.04 16.06 15.32 15.7C15.71 15.2 16.32 14.87 17.01 14.87C17.55 14.87 18.04 15.07 18.41 15.39C18.86 15.79 19.15 16.37 19.15 17.01C19.15 18.19 18.19 19.15 17.01 19.15Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1501 17.01C19.1501 18.19 18.1901 19.15 17.0101 19.15C15.8301 19.15 14.8701 18.19 14.8701 17.01C14.8701 16.52 15.0401 16.06 15.3201 15.7C15.7101 15.2 16.3201 14.87 17.0101 14.87C17.5501 14.87 18.0401 15.07 18.4101 15.39C18.8601 15.79 19.1501 16.37 19.1501 17.01Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0099 12.73C17.6009 12.73 18.0799 12.251 18.0799 11.66C18.0799 11.0691 17.6009 10.5901 17.0099 10.5901C16.419 10.5901 15.9399 11.0691 15.9399 11.66C15.9399 12.251 16.419 12.73 17.0099 12.73Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDevices);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "devices.7a7a79423f5abca13740681843c1b342.svg";